import React from 'react';
import { LoadingSpinner } from './LoadingSpinner';

export function PageLoader() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-custom-orange-50 via-custom-orange-100 to-custom-orange-200 flex items-center justify-center p-4">
      <div className="bg-white p-8 rounded-[30px] shadow-xl">
        <LoadingSpinner size="lg" />
        <p className="mt-4 text-gray-600 text-center">Loading...</p>
      </div>
    </div>
  );
}